import { module } from 'angular';
import templateBuilderDatagridDisplay from './builder/display.html';
import templateBuilderDatagridValidate from './builder/validate.html';

export default module('app').run(/* @ngInject */ (
	/** @type {import('angular').ITemplateCacheService} */ $templateCache,
) => {
	$templateCache.put('kform/components/datagrid/display.html', templateBuilderDatagridDisplay);
	$templateCache.put('kform/components/datagrid/validate.html', templateBuilderDatagridValidate);
});
